import React, {useEffect} from "react";
import {Card, CardBody, Pagination} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {useMetadata} from "../../../../../_emywork/AEPagination";
import {CONTEXT} from "../../helpers/ModuleHelpers";
import {actionTypes} from "../../_redux/slice";
import {fetchEntities} from "../../_redux/actions";
import {AESpinner} from "../../../../../_emywork/spinner/AESpinner";
import {ModuleProvider as EmyProjectModuleProvider, useModuleContext as useEmyProjectModuleContext} from "../../../EmyProjects/ModuleContext";
import {EmyProposalStatus} from "../../../EmyProjects/componants/Status";
import {EntityCard as UserEntityCard} from "../../../Users/componants/EntityCard";
import {EntityCard as EmyProjectEntityCard} from "../../../EmyProjects/componants/EntityCard";
import {AECurrency} from "../../../../../_emywork/components/Currency";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {AESVG} from "../../../../../_emywork/components/svg";
import {useIntl} from "react-intl";
import {ProposalDetailsModal} from "../../../EmyProjects/dialogs/ProposalDetailsModal";
import {roles} from "../../../../App";
import {getConfig} from "../../../../../_metronic/i18n";

export const List = props =>
  <EmyProjectModuleProvider>
    <ListContent {...props} />
  </EmyProjectModuleProvider>

export function ListContent() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const {openProposalDetailsDialog} = useEmyProjectModuleContext()
  const {role} = getConfig()
  const {authUser} = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );


  const { entities, meta, isLoading } = useSelector(
    state => state[CONTEXT][actionTypes.List]
    , shallowEqual )
  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select, setSort, setFilters } = metadata;

  const getEntities = () => {
    let md = {...metadata.toAEMetadata()};
    switch (role) {
      case roles.provider : md.filters.user_id = authUser.id; break;
      // case roles.client : md.filters.user_id = authUser.id; break;
    }

    dispatch(fetchEntities(md));
  }

  useEffect(() => {
    getEntities()
  }, [dispatch, page, perPage, filters, select, sortField, sortAsc]);


  const SortField = ({field, title, sortable = false})=>{
    const isSame = sortField === field;

    return (
      <AEButton
        variant={'link-dark'}
        className={`p-0 ${!sortable ? 'cursor-default' : ''}`}
        onClick={()=>{
          if(sortable){
            setSort(field, !sortAsc)
          }

        }}
      >
        {title}
        {
          isSame &&
          <AESVG
            path={`/Navigation/${sortAsc ? 'Arrow-down':'Arrow-up'}.svg`}
            // variant={'dark'}
          />
        }

      </AEButton>
    )
  }

  return (
    <>
      {/*<Filter {...metadata} isLoading={isLoading}/>*/}
      <ProposalDetailsModal onSave={getEntities}/>

      <Card>
        <CardBody>
          <div className="table-responsive">
            <table className="table table-head-custom table-vertical-center table-head-bg table-borderless">
              <thead>
              <tr className="text-left">
                <th  className="text-dark-75">
                  <SortField field={'project'} title={formatMessage({id:'EMY_PROJECT'})} sortable/>
                </th>
                {
                  [roles.client, roles.super_admin].includes(role) &&
                  <th  className="text-dark-75">
                    <SortField field={'user_id'} title={formatMessage({id:'ROLE_PROVIDER'})} sortable/>
                  </th>
                }
                <th>
                  <SortField field={'price'} title={formatMessage({id:'PRICE'})} sortable/>
                </th>
                <th>
                  <SortField field={'status'} title={formatMessage({id:'STATUS'})}/>
                </th>
                {/*<th>*/}
                {/*  <SortField field={'provider_status'} title={formatMessage({id:'PROVIDER_STATUS'})} sortable/>*/}
                {/*</th>*/}
                <th />
              </tr>
              </thead>
              <tbody>
              {
                isLoading ?
                  <tr className={'text-center'}>
                    <td colSpan={10}>
                      <AESpinner />
                    </td>
                  </tr> :
                  entities
                    .map(({id, price, note, status, provider_status, created_at, project, created_by})=>(
                      <tr key={id}>
                        <td>
                          <EmyProjectEntityCard
                            size={"xs"}
                            entity={project}
                          />
                        </td>
                        {
                          [roles.client, roles.super_admin].includes(role) &&
                          <td className="">
                            <UserEntityCard
                              entity={created_by}
                              size={"xs"}
                              className={'mb-0'}
                            />
                            {/*<ProviderEntityCard entity={created_by} size={"xs"}/>*/}
                          </td>
                        }
                        <td>
                          <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                            <AECurrency value={price} />
                          </span>
                          <span className="text-muted font-weight-bold">
                            {/*<EmyProposalStatus status={status} />*/}
                            {formatMessage({id:provider_status})}
                          </span>
                        </td>
                        <td>
                          <EmyProposalStatus status={status} />
                        </td>

                        <td className="pr-0 text-right">
                          <AEButton
                            icon
                            variant={'clean'}
                            size={'sm'}
                            onClick={()=>{
                              openProposalDetailsDialog(id)
                            }} >
                            <AESVG
                              path={'/General/Settings-1.svg'}
                            />
                            {/*{formatMessage({id:'VIEW_OFFER'})}*/}
                          </AEButton>
                        </td>
                      </tr>
                    ))

              }
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>

      <Pagination
        {...metadata}
        // counts={[12, 24, 48, 96]}
      />
    </>
  );
}
